// import { defineNuxtPlugin } from "nuxt/app"

// export default defineNuxtPlugin(async (nuxtApp) => {
//   const push = {
//     permissionGranted: null,
//     idToken: null,
//     listenersStarted: false,

//     notificationStatus(status) {
//       if (status === 'denied' || status === 'default') {
//         return false
//       } else if (status === 'granted') {
//         return true
//       }
//       return true
//     },

//     async requestPermission() {
//       try {
//         const permission = await Notification.requestPermission()
//         this.permissionGranted = permission === 'granted'
//         return this.notificationStatus(permission)
//       } catch (e) {
//         return false
//       }
//     },

//     addTokenToDB() {
//       if (!this.idToken) return

//       const data = { token: this.idToken }

//       fetch(`${process.env.BASE_URL}/tokens`, {
//         method: 'POST',
//         body: JSON.stringify(data),
//         headers: {
//           'Content-Type': 'application/json',
//           authorization: `Bearer ${nuxtApp.$strapi.getToken()}`
//         }
//       }).catch(() => {})
//     },

//     async getIdToken() {
//       try {
//         const currentToken = await nuxtApp.$fire.messaging.getToken()
//         if (currentToken) {
//           this.idToken = currentToken
//           this.addTokenToDB()
//         } else {
//           this.idToken = ''
//         }
//       } catch (e) {
//         this.idToken = ''
//       }
//     },

//     startListeners() {
//       if (this.listenersStarted) return
//       this.startOnMessageListener()
//       this.startTokenRefreshListener()
//       this.listenersStarted = true
//     },

//     startOnMessageListener() {
//       nuxtApp.$fire.messaging.onMessage((payload) => {
//         // Example: commit to store
//         // nuxtApp.$piniaStore.notifications.push(payload)
//       })
//     },

//     startTokenRefreshListener() {
//       nuxtApp.$fire.messaging.onTokenRefresh(async () => {
//         try {
//           const refreshedToken = await nuxtApp.$fire.messaging.getToken()
//           this.idToken = refreshedToken
//           this.addTokenToDB()
//         } catch (e) {}
//       })
//     },

//     async start() {
//       if (await this.requestPermission()) {
//         await this.getIdToken()
//         if (this.idToken) this.startListeners()
//       }
//     }
//   }

//   // Wait for Firebase messaging to be ready (optional, depending on your firebase plugin)
//   if (nuxtApp.$fire.messagingReady) {
//     await nuxtApp.$fire.messagingReady()
//   }

//   // Inject globally
//   nuxtApp.provide('push', push)
//   nuxtApp.$push = push
// })
